import React, {FC} from 'react';
import classNames from 'classnames';
import {MobileProvider} from 'hooks/useIsMobile';
import {useRotate} from 'hooks/useRotate';

import * as styles from './styles.module.scss';

type ChartsProps = {
	children: React.ReactNode[]
}

const Charts: FC<ChartsProps> = ({children}) => {
	const mobile = useRotate(children);
	return (
		<>
			<MobileProvider>
				<div className={classNames(styles.wrapper, styles.mobile)}>
					{mobile}
				</div>
			</MobileProvider>
			<div className={classNames(styles.wrapper, styles.desktop)}>
				{children}
			</div>
		</>
	);
};

export default Charts;
